import { RecordDto } from "@/core/common/entities/record.dto";
import { getReportTemplateRecordLabel, ReportTemplateRecordTypeEnum } from "@altertec_gparn/lib";
import { reportSectionTranslate } from "@/core/features/report-templates/translations/report-section.translate";
import { get } from "lodash";

export class ReportTemplateRecordDto extends RecordDto {
  reportTemplateId: string;
  translateEntityName = "la platilla";

  // @Override
  getTargetField(): string {
    if (!this.targetField) return;
    return get(reportSectionTranslate, this.targetField, this.targetField);
  }

  // @Override
  getSubtype(): string {
    return getReportTemplateRecordLabel(this.subtype as ReportTemplateRecordTypeEnum, "plantilla");
  }
}
